import clsx from 'clsx';

export interface PopupTitleProps {
  text: string;
  textHeadingCounter?: string;
  className?: string;
}

const PopupTitle = ({
  text,
  textHeadingCounter = '',
  className,
}: PopupTitleProps) => (
  <p
    className={clsx(
      'font-montserrat text-[24px]/[34px] font-semibold text-brand-white-100',
      className,
    )}
  >
    {textHeadingCounter && <span className="block">{textHeadingCounter}</span>}
    {text}
  </p>
);

export default PopupTitle;
